import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getPageVisibilityState } from '../hidden-timing';
import { withProfiling } from '../self-measurements';
import { VCObserver } from '../vc/vc-observer';
var interactionBuffer = [];
var bufferInteractionData = withProfiling(function bufferInteractionData(interactionId, data) {
  interactionBuffer.push({
    interactionId: interactionId,
    data: data
  });
});
var clearInteractionBuffer = withProfiling(function clearInteractionBuffer() {
  interactionBuffer.length = 0;
});
var appendInteractionData = withProfiling(function appendInteractionData(interactionId, data) {
  bufferInteractionData(interactionId, data);
});
export var installInteractionSink = withProfiling(function installInteractionSink(handler) {
  for (var _i = 0, _interactionBuffer = interactionBuffer; _i < _interactionBuffer.length; _i++) {
    var _interactionBuffer$_i = _interactionBuffer[_i],
      _interactionId = _interactionBuffer$_i.interactionId,
      data = _interactionBuffer$_i.data;
    handler(_interactionId, data);
  }
  clearInteractionBuffer();
  bufferInteractionData = withProfiling(handler);
});
export var sinkExperimentalHandler = withProfiling(function sinkExperimentalHandler(sinkFn) {
  installInteractionSink(sinkFn);
});
export var onExperimentalInteractionComplete = withProfiling(function onExperimentalInteractionComplete(interactionId, data) {
  var endTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
  if (data.ufoName) {
    data.end = endTime;
    appendInteractionData(interactionId, data);
    clearInteractionBuffer();
  }
});
export var ExperimentalVCMetrics = /*#__PURE__*/function () {
  function ExperimentalVCMetrics() {
    _classCallCheck(this, ExperimentalVCMetrics);
    _defineProperty(this, "vcObserver", null);
    this.initialize = withProfiling(this.initialize.bind(this));
    this.start = withProfiling(this.start.bind(this));
  }
  return _createClass(ExperimentalVCMetrics, [{
    key: "initialize",
    value: function initialize(options) {
      if (this.vcObserver === null) {
        this.vcObserver = new VCObserver(_objectSpread(_objectSpread({}, options), {}, {
          isPostInteraction: true
        }));
      }
      return this;
    }
  }, {
    key: "start",
    value: function start(_ref) {
      var _this$vcObserver;
      var startTime = _ref.startTime;
      (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
        startTime: startTime
      });
    }
  }]);
}();
export var experimentalVC = new ExperimentalVCMetrics();
export var getExperimentalVCMetrics = withProfiling( /*#__PURE__*/function () {
  var _getExperimentalVCMetrics = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(interaction) {
    var _interaction$apdex, prefix, result, VC, pageVisibilityUpToTTAI;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!experimentalVC.vcObserver) {
            _context.next = 12;
            break;
          }
          prefix = 'ufo-experimental';
          _context.next = 4;
          return experimentalVC.vcObserver.getVCResult({
            start: interaction.start,
            stop: interaction.end,
            tti: (_interaction$apdex = interaction.apdex) === null || _interaction$apdex === void 0 || (_interaction$apdex = _interaction$apdex[0]) === null || _interaction$apdex === void 0 ? void 0 : _interaction$apdex.stopTime,
            isEventAborted: !!interaction.abortReason,
            prefix: prefix,
            vc: interaction.vc
          });
        case 4:
          result = _context.sent;
          VC = result === null || result === void 0 ? void 0 : result['metrics:vc'];
          if (!(!VC || !(result !== null && result !== void 0 && result["".concat(prefix, ":vc:clean")]))) {
            _context.next = 8;
            break;
          }
          return _context.abrupt("return", result);
        case 8:
          pageVisibilityUpToTTAI = getPageVisibilityState(interaction.start, interaction.end);
          if (!(interaction.abortReason || pageVisibilityUpToTTAI !== 'visible')) {
            _context.next = 11;
            break;
          }
          return _context.abrupt("return", result);
        case 11:
          return _context.abrupt("return", _objectSpread(_objectSpread({}, result), {}, {
            'metric:experimental:vc90': VC['90']
          }));
        case 12:
          return _context.abrupt("return", null);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  function getExperimentalVCMetrics(_x) {
    return _getExperimentalVCMetrics.apply(this, arguments);
  }
  return getExperimentalVCMetrics;
}());